import { Injectable } from '@angular/core';
import { RestService } from '../../services/common';

@Injectable({
  providedIn: 'root'
})
export class AcquisitionService {

  constructor(private restService: RestService) { }

  filterKhasra(id?: any, villageId?: any, tehsilId?: any, landKhataId?: any, farmerId?: any, isActive: boolean = true) {
    var localUrl: any = 'acquisition/landkhasra';

    if (id || villageId || tehsilId || landKhataId || farmerId || isActive) localUrl += '?'

    //Set all filters params if available
    if (id) localUrl += 'id=' + id
    localUrl = villageId ? id ? localUrl + '&villageId=' + villageId : localUrl + 'villageId=' + villageId : localUrl
    localUrl = tehsilId ? (id || villageId) ? localUrl + '&tehsilId=' + tehsilId : localUrl + 'tehsilId=' + tehsilId : localUrl
    localUrl = landKhataId ? (id || villageId || tehsilId) ? localUrl + '&landKhataId=' + landKhataId : localUrl + 'landKhataId=' + landKhataId : localUrl
    localUrl = farmerId ? (id || villageId || tehsilId || landKhataId) ? localUrl + '&farmerId=' + farmerId : localUrl + 'farmerId=' + farmerId : localUrl
    localUrl = isActive ? (id || villageId || tehsilId || landKhataId || farmerId) ? localUrl + '&isActive=' + isActive : localUrl + 'isActive=' + isActive : localUrl
    return this.restService.getData(localUrl);
  }

  getKhasra() {
    return this.restService.getData("acquisition/landKhasra?isActive=true")
  }

  getFarmer() {
    return this.restService.getData("acquisition/farmer?isActive=true");
  }

  getKhasraById(id: any) {
    return this.restService.getData('acquisition/landKhasra?id=' + id + '&isActive=true')
  }

  getFarmerById(id: any) {
    return this.restService.getData('acquisition/farmer?id=' + id + '&isActive=true')
  }
}
